
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("djl9a", function(module, exports) {
$parcel$export(module.exports, "ConnectorSetupModalHost", () => (parcelRequire("8TCoR")).ConnectorSetupModalHost);

var $8TCoR = parcelRequire("8TCoR");


});

parcelRegister("fzrJO", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9639879ef0d0f478$var$initialState = {
    activeConnectorKey: null,
    connectedConnectorKeys: []
};
const $9639879ef0d0f478$var$actions = {
    openSetupModal: (connectorKey)=>({ setState: setState })=>{
            setState({
                activeConnectorKey: connectorKey
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                activeConnectorKey: null
            });
        },
    markConnectorConnected: (connectorKey)=>({ getState: getState, setState: setState })=>{
            const { connectedConnectorKeys: connectedConnectorKeys } = getState();
            if (connectedConnectorKeys.includes(connectorKey)) return;
            setState({
                connectedConnectorKeys: [
                    ...connectedConnectorKeys,
                    connectorKey
                ]
            });
        }
};
const $9639879ef0d0f478$var$SetupConnectorStore = (0, $1P1Tu.createStore)({
    initialState: $9639879ef0d0f478$var$initialState,
    actions: $9639879ef0d0f478$var$actions,
    name: 'Twcg1489SetupConnectorStore'
});
const $9639879ef0d0f478$export$86bfee7a4a335f62 = (0, $9zUhf.createActionsHook)($9639879ef0d0f478$var$SetupConnectorStore);
const $9639879ef0d0f478$var$useActiveConnectorKey = (0, $9zUhf.createStateHook)($9639879ef0d0f478$var$SetupConnectorStore, {
    selector: (state)=>state.activeConnectorKey
});
const $9639879ef0d0f478$export$c3af49e60e4baf22 = (0, $9zUhf.createStateHook)($9639879ef0d0f478$var$SetupConnectorStore, {
    selector: (state)=>state.connectedConnectorKeys
});
function $9639879ef0d0f478$export$3ccb24b32789bc60() {
    const activeConnectorKey = $9639879ef0d0f478$var$useActiveConnectorKey();
    const { openSetupModal: openSetupModal, closeModal: closeModal } = $9639879ef0d0f478$export$86bfee7a4a335f62();
    return {
        openSetupModal: openSetupModal,
        activeConnectorKey: activeConnectorKey,
        closeModal: closeModal
    };
}
module.exports["useSetupConnectorActions"] = $9639879ef0d0f478$export$86bfee7a4a335f62;
module.exports["useConnectedConnectorKeys"] = $9639879ef0d0f478$export$c3af49e60e4baf22;
module.exports["useSetupConnector"] = $9639879ef0d0f478$export$3ccb24b32789bc60;

});

parcelRegister("jFMyq", function(module, exports) {

let $e52782808235e1b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e52782808235e1b9$var$load("fAtWn"),
    $e52782808235e1b9$var$load("iPYAE"),
    $e52782808235e1b9$var$load("5lTVp"),
    $e52782808235e1b9$var$load("lWNY8"),
    $e52782808235e1b9$var$load("jPuvo"),
    $e52782808235e1b9$var$load("hXbzh"),
    $e52782808235e1b9$var$load("6wr18"),
    $e52782808235e1b9$var$load("6uCgj"),
    $e52782808235e1b9$var$load("khyhL"),
    $e52782808235e1b9$var$load("llxGi"),
    $e52782808235e1b9$var$load("g4qer"),
    $e52782808235e1b9$var$load("kHOMt"),
    $e52782808235e1b9$var$load("dek7I"),
    $e52782808235e1b9$var$load("dYtBN"),
    $e52782808235e1b9$var$load("kNV5Y"),
    $e52782808235e1b9$var$load("dhOT8"),
    $e52782808235e1b9$var$load("ffEVr"),
    $e52782808235e1b9$var$load("hhss7"),
    $e52782808235e1b9$var$load("7j0mT"),
    $e52782808235e1b9$var$load("69R9L"),
    $e52782808235e1b9$var$load("kuFG2"),
    $e52782808235e1b9$var$load("Wowvf"),
    $e52782808235e1b9$var$load("1F7LX"),
    $e52782808235e1b9$var$load("7EorR"),
    $e52782808235e1b9$var$load("e0ufb")
]).then(()=>parcelRequire('elniL'));

});

parcelRegister("8TCoR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $fzrJO = parcelRequire("fzrJO");

/* SetupConnectorModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $aXWIB = parcelRequire("aXWIB");


var $1DHa6 = parcelRequire("1DHa6");


var $9ot3w = parcelRequire("9ot3w");


var $6xdDU = parcelRequire("6xdDU");


var $1s5hv = parcelRequire("1s5hv");


var $9hlns = parcelRequire("9hlns");


var $jmjWc = parcelRequire("jmjWc");


var $lsxnT = parcelRequire("lsxnT");


var $7aRa9 = parcelRequire("7aRa9");

const $7b4c3164a2ba2be7$var$styles = {
    loadingContainer: "_1tke1vif"
};
const $7b4c3164a2ba2be7$var$messages = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.setup-connector-modal.error-title",
        defaultMessage: "Connector form could not be loaded"
    },
    errorDescription: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.setup-connector-modal.error-description",
        defaultMessage: "Something went wrong. Please try again."
    }
});
const $7b4c3164a2ba2be7$var$loadingContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
    hasCloseButton: true
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), {
    hasInlinePadding: false
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
    xcss: $7b4c3164a2ba2be7$var$styles.loadingContainer,
    justifyContent: "center",
    alignItems: "center"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
    size: "xlarge"
}))));

/**
 * Lazily loaded modal that renders the third-party connector connect form.
 *
 * ModalTransition and Modal are rendered here (in the eagerly-loaded chunk)
 * so the modal backdrop appears immediately while the connector form chunk
 * is loading. The spinner renders inside the modal shell during load.
 *
 * Uses @confluence/loadable (not React.lazy) for Confluence-standard code
 * splitting with SSR compatibility and built-in error handling.
 *
 * The package uses react-relay so Confluence's existing Relay environment
 * is used directly — no additional provider wrapping is needed.
 */ const $7b4c3164a2ba2be7$var$LazyConnectorModalContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "3CACP",
    name: "LazyConnectorModalContent",
    loader: async ()=>(await (parcelRequire("jFMyq"))).SetupConnectorModalContent,
    loading: ()=>$7b4c3164a2ba2be7$var$loadingContent
});
function $7b4c3164a2ba2be7$var$SetupConnectorModalWithFlags({ connectorKey: connectorKey, onClose: onClose, flags: flags }) {
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const onError = (0, $42omo.useCallback)(()=>{
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $7b4c3164a2ba2be7$var$messages.errorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $7b4c3164a2ba2be7$var$messages.errorDescription),
            isAutoDismiss: true
        });
        onClose();
    }, [
        flags,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: onClose,
        width: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4c3164a2ba2be7$var$LazyConnectorModalContent, {
        connectorKey: connectorKey,
        onClose: onClose,
        loadingContent: $7b4c3164a2ba2be7$var$loadingContent,
        onError: onError
    })));
}
const $7b4c3164a2ba2be7$export$c72f879a0467d3fa = (0, $7aRa9.withFlags)($7b4c3164a2ba2be7$var$SetupConnectorModalWithFlags);


function $5d3b6015a7914fc9$export$b07462ee6aa46956() {
    const { activeConnectorKey: activeConnectorKey, closeModal: closeModal } = (0, $fzrJO.useSetupConnector)();
    if (!activeConnectorKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_CFIND
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7b4c3164a2ba2be7$export$c72f879a0467d3fa), {
        connectorKey: activeConnectorKey,
        onClose: closeModal
    }));
}
module.exports["ConnectorSetupModalHost"] = $5d3b6015a7914fc9$export$b07462ee6aa46956;

});


//# sourceMappingURL=ConnectorSetupModalHost.6678f8ce.js.map
